var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';
export const GridList = (props) => {
    const { children, columns = 3, className } = props;
    const columnsClsx = {
        'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3': columns === 3,
        'grid-cols-1 lg:grid-cols-3 xl:grid-cols-4': columns === 4,
    };
    return (React.createElement("ul", { className: twMerge(clsx('grid gap-5', columnsClsx, className)) }, children));
};
const GridListItem = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (React.createElement("li", Object.assign({ className: "col-span-1" }, rest), children));
};
GridList.Item = GridListItem;
//# sourceMappingURL=GridList.js.map